import { apiGetUser } from '@/modules/User/services/authentication'
import { USER_MODULE_NAME, USER_SET_ROLE, USER_SET_ID } from '@/modules/User/store/types'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_FORMID,
  WARRANTY_UPDATE_SINID
} from '@/store/types'
import { FLOW_MODULE_NAME, FLOW_SET_ERROR } from '@/modules/Flow/store/types'
import { apiGetSendOtp } from '../services/authentication'
import userModule from '@/modules/User/store'
import { mapActions } from 'vuex'
import { prepareErrorForSentry } from '@/utils/errorHandling'
import { errorsTrack } from '@/utils/registeredErrors'
/**
 * @module
 * @name authRoutersBuilder
 * @description Mixin which contains utils used for login purposes.
 */
export default {
  /**
   * @property {String} user.username Username.
   * @property {String} user.password Password.
   */
  data: function () {
    return {
      user: {
        username: '',
        password: ''
      }
    }
  },

  methods: {
    ...mapActions(USER_MODULE_NAME, {
      actUserSetRole: USER_SET_ROLE,
      actUserSetId: USER_SET_ID
    }),
    ...mapActions(WARRANTY_MODULE_NAME, {
      updateWarrantyId: WARRANTY_UPDATE_FORMID,
      updateSinisterId: WARRANTY_UPDATE_SINID
    }),

    ...mapActions(FLOW_MODULE_NAME, {
      actFlowSetError: FLOW_SET_ERROR
    }),

    async getUserToken() {
      try {
        const userToken = await apiGetToken()
        if ('token' in userToken) {
          sessionStorage.setItem('mavAuth', `Token ${userToken.token}`)
        }
        return userToken
      } catch (e) {
        throw new Error(e)
      }
    },

    async getUserData() {
      try {
        const userData = await apiGetUser()
        if (userData.role) this.actUserSetRole(userData.role)
        if (userData.user_id) this.actUserSetId(userData.user_id)
      } catch (e) {
        throw new Error(e)
      }
    },

    async getOtpStatus(sinisterId = this.getSinisterId) {
      return apiGetSendOtp(sinisterId)
        .then((data) => {
          sessionStorage.setItem('sinId', data.sinisterId)
          sessionStorage.setItem('formId', data.formId)
          sessionStorage.setItem('telephone', data.telephone)
          sessionStorage.setItem('otpSent', true)

          this.updateWarrantyId(data.formId)
          this.updateSinisterId(data.sinisterId)
        })
        .catch((e) => {
        // Check that error is not in the array already
          const errorStr = `${e.message} on handleResendSMS.getOtpStatus - ${e.response.data.message}`
          if (!errorsTrack.includes(errorStr)) errorsTrack.push(errorStr)

          // Create error context tags
          const context = {
            component: 'userLoginMixin',
            method: 'getOtpStatus',
            route: this.$route.path
          }
          const tags = prepareErrorForSentry(e, context, { willRedirect: true })

          const err = e.response.status >= 500 && e.response.status < 600 ? 'error' : 'warning'
          this.sendSentryError(errorStr, err, tags, this.$route.query.sinisterId, 'handleResendSMS.getOtpStatus')
          this.actFlowSetError(e.response.data.message)
          this.goToErrorView(this.$route.query)
        })
    }
  },
  /**
   * @function
   * @name beforeCreate
   * @description Registers the user module if it's not registered
   */
  beforeCreate: function () {
    if (!(USER_MODULE_NAME in this.$store.state)) {
      this.$store.registerModule(USER_MODULE_NAME, userModule)
    }
  }
}
